// extracted by extract-css-chunks-webpack-plugin
module.exports = {"grid-panel":"styles__grid-panel___5ahZf","gridPanel":"styles__grid-panel___5ahZf","grid-row":"styles__grid-row___dQC6q","gridRow":"styles__grid-row___dQC6q","row-label":"styles__row-label___3Me-D","rowLabel":"styles__row-label___3Me-D","row-value":"styles__row-value___2NOMU","rowValue":"styles__row-value___2NOMU","dollar":"styles__dollar___jltGy"};
    if(module.hot) {
      // 1679539924364
      var cssReload = require("../../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  